@if (open()) {
  <div class="voice-overlay" [class.is-touring]="touring()"
    [style.height]="viewportHeight()" [style.top]="viewportTop()">
    <div class="voice-overlay__backdrop" (click)="onBackdropClick()"></div>

    <!-- Fenêtre modale (MOKA-363) : focus enfermé, sauf pendant la visite guidée (Driver.js). -->
    <div class="voice-overlay__panel" role="dialog" aria-modal="true" aria-labelledby="koffi-title"
      [cdkTrapFocus]="!touring()">
      <h2 id="koffi-title" class="voice-overlay__title">Koffi, votre assistant</h2>
      @if (assistantEnabled()) {
        <app-tutorial-button class="voice-overlay__tour-btn" [tutorial]="tour" [compact]="true" />
      }

      <button
        type="button"
        data-tour="assistant.overlay.history"
        class="voice-overlay__history-btn"
        (click)="toggleHistory()"
        aria-label="Historique des conversations"
        title="Historique"
      >
        <ng-icon name="iconoirClockRotateRight" size="18" />
      </button>

      <button
        type="button"
        class="voice-overlay__close-btn"
        (click)="close()"
        aria-label="Fermer l'assistant vocal"
        title="Fermer"
      >
        <ng-icon name="iconoirXmark" size="20" />
      </button>

      @if (showHistory()) {
        <div class="voice-overlay__history-side">
          @if (historyError()) {
            <p class="voice-overlay__history-error">{{ historyError() }}</p>
          }
          <app-voice-session-history
            (sessionSelected)="onHistorySessionSelected($event)"
            (newConversation)="onHistoryNewConversation()"
            (activeSessionDeleted)="onHistoryActiveSessionDeleted()"
          />
        </div>
      } @else {
        <div class="voice-overlay__chat-side">
          <app-voice-chat-thread
            [messages]="voiceSession.messages()"
            [pendingFollowUp]="voiceSession.pendingFollowUp()"
            [activeConfirmationId]="voiceService.pendingConfirmationId()"
            [isProcessing]="voiceService.isProcessing()"
            [isRecording]="voiceService.isRecording()"
            [isSpeaking]="voiceService.isSpeaking()"
            [liveTranscript]="voiceService.transcript()"
            [hasError]="voiceService.hasError()"
            [error]="voiceService.error()"
            [canRetry]="!!voiceService.lastFailedText() && !voiceService.isProcessing()"
            (retry)="onRetry()"
            (sendText)="onSendText($event)"
            (startVoice)="onStartVoice()"
            (stopVoice)="onStopVoice()"
            (quickAction)="onQuickAction($event)"
            (optionSelected)="onOptionSelected($event)"
            (linkSelected)="onLinkSelected($event)"
          />

          <p class="voice-overlay__privacy-note" data-tour="assistant.overlay.privacy">
            Vos demandes sont traitées par un service tiers (OpenAI).
            <a routerLink="/documents/privacy-policy" (click)="close()">En savoir plus</a>
          </p>
        </div>
      }
    </div>
  </div>
}
